<div cdkScrollable class="border-[1.5px] border-gray-200 rounded-xl bg-white py-5 shadow-sm text-sm w-full relative max-h-[30rem] overflow-auto">
  
  <!-- Header -->
  <div class="flex justify-between items-end mb-4 border-b border-gray-400 pb-3 px-5">
    <h3 class="text-primary_Text_Color poppinsSemiBold text-sm">Filter by</h3>
    <div class="flex items-center gap-8">
      <button type="button" (click)="resetAll()" class="text-xs 2xl:text-sm poppinsMedium textBasedActions">Reset All</button>
      <button 
            type="button"
            class="grid size-5 place-items-center rounded-full text-slate-500 hover:bg-slate-100"
             (click)="this.resetAll();closeBuilder.emit()"
            (mouseenter)="currentCloseImg = hoverCloseImg"
            (mouseleave)="currentCloseImg = defaultCloseImg"
            aria-label="Close dialog"
          >
            <img [src]="currentCloseImg" alt="crossIcon" class="w-4 h-4" />
          </button>    
    </div>
  </div>

  <form [formGroup]="filterForm" >
    <!-- Filter Name -->
    <div class="px-5 mb-6 flex gap-3">
      <label for="filterName" class="block text-primary_Text_Color poppinsMedium text-xs mb-2 whitespace-nowrap mt-3">Filter Name</label>
      <div class="flex-1 min-w-0">
      <input appAppNoSpaces id="filterName" type="text" formControlName="filterName" placeholder="Enter custom filter name"
             [ngClass]="{'has-error': filterForm.get('filterName')?.invalid && (filterForm.get('filterName')?.dirty || filterForm.get('filterName')?.touched)}"
             [attr.aria-invalid]="filterForm.get('filterName')?.invalid && (filterForm.get('filterName')?.dirty || filterForm.get('filterName')?.touched)"
             aria-describedby="filterNameError"
             class="input-field text-xs !py-0 !px-4 min-h-10 poppinsMedium placeholder:text-xs placeholder!:text-secondary_Light_Text_Color">
      <p id="filterNameError" aria-live="polite" class="text-red_600 text-xs poppinsMedium mt-1"
         *ngIf="filterForm.get('filterName')?.invalid && (filterForm.get('filterName')?.dirty || filterForm.get('filterName')?.touched)">
        <span *ngIf="filterForm.get('filterName')?.hasError('required')">Filter name is required.</span>
        <span *ngIf="filterForm.get('filterName')?.hasError('maxlength')">Filter name cannot exceed 200 characters.</span>
      </p>
      </div>
    </div>

    <!-- Conditions Array -->
    <div formArrayName="conditions" class="space-y-6 px-10 mb-6">
      <div *ngFor="let condition of conditions.controls; let i=index" [formGroupName]="i" class="flex items-center gap-4">
        
        <!-- Logical Operator / Where Label -->
        <div class="w-20 relative">
          <div *ngIf="i === 0" class="text-primary_Text_Color poppinsMedium text-xs font-medium">Where</div>
          
          <!-- Interactive operator selector only for the first operator (i === 1) -->
          <ng-container *ngIf="i === 1">
            <div
                 class="custom-select-trigger hoverShadow w-full cursor-pointer text-primary_Text_Color rounded-md border border-gray-200 px-4 text-xs bg-white outline-none poppinsMedium"
                 [class.border-primary_Bg_Button_Color]="isDropdownOpen('operator', i)"
                 cdkOverlayOrigin #operatorOrigin="cdkOverlayOrigin"
                 role="combobox"
                 tabindex="0"
                 aria-label="Logical operator"
                 aria-haspopup="listbox"
                 [attr.aria-expanded]="isDropdownOpen('operator', i)"
                 (click)="toggleDropdown('operator', i, $event)"
                 (keydown)="handleDropdownKeydown($event, 'operator', i)">
              <span>{{ condition.get('logicalOperator')?.value }}</span>
              <img [src]="commonService.Images.DROPDOWN_ICON_NEW_UX"
                   class="w-3 h-3 transition-transform duration-200"
                   alt=""
                   aria-hidden="true"
                   [class.rotate-180]="isDropdownOpen('operator', i)" />
            </div>
            <ng-template cdkConnectedOverlay
                 [cdkConnectedOverlayOrigin]="operatorOrigin"
                 [cdkConnectedOverlayOpen]="i === 1 && isDropdownOpen('operator', i) && operatorOrigin.elementRef.nativeElement.offsetWidth > 0"
                 [cdkConnectedOverlayWidth]="isDropdownOpen('operator', i) ? operatorOrigin.elementRef.nativeElement.offsetWidth : 0"
                 [cdkConnectedOverlayPositions]="dropdownPositions"
                 [cdkConnectedOverlayPush]="true"
                 [cdkConnectedOverlayViewportMargin]="8"
                 (overlayKeydown)="$event.key === 'Escape' && closeDropdown()"
                 (detach)="onDropdownDetached('operator', i)">
              <div
                 class="custom-select-menu "
                 role="listbox"
                 aria-label="Logical operator options">
              <div *ngFor="let operator of ['AND', 'OR']"
                   class="custom-select-option !py-0 min-h-10"
                   [class.custom-select-option--selected]="condition.get('logicalOperator')?.value === operator"
                   role="option"
                   tabindex="0"
                   [attr.aria-selected]="condition.get('logicalOperator')?.value === operator"
                   (click)="selectOperator($any(operator), i, $event)"
                   (keydown.enter)="selectOperator($any(operator), i, $event)"
                   (keydown.space)="$event.preventDefault(); selectOperator($any(operator), i, $event)">
                {{ operator }}
              </div>
            </div>
            </ng-template>
          </ng-container>

          <!-- Non-interactive display div for i >= 2 -->
          <div *ngIf="i >= 2" class="w-full flex items-center text-primary_Text_Color cursor-not-allowed rounded-md border border-gray-200 p-4 text-xs bg-gray-100 outline-none poppinsMedium">
            {{ condition.get('logicalOperator')?.value }}
          </div>
        </div>

        <!-- Field Selection -->
        <div class="flex-1 relative w-[20rem] min-w-0">
          <div class="custom-select-trigger hoverShadow text-xs rounded-md border border-card_number_color px-4 bg-white text-primary_Text_Color outline-none poppinsMedium cursor-pointer"
               [ngClass]="{
                 'border-red_600': condition.get('fieldKey')?.invalid && condition.get('fieldKey')?.touched,
                 'border-primary_Bg_Button_Color': isDropdownOpen('field', i),
                 '!text-secondary_Light_Text_Color': !isDropdownOpen('field', i) && condition.get('fieldKey')?.invalid
               }"
               cdkOverlayOrigin #fieldOrigin="cdkOverlayOrigin"
               role="combobox"
               tabindex="0"
               [attr.aria-label]="'Field for condition ' + (i + 1)"
               aria-haspopup="listbox"
               [attr.aria-expanded]="isDropdownOpen('field', i)"
               (click)="toggleDropdown('field', i, $event)"
               (keydown)="handleDropdownKeydown($event, 'field', i)">
            <span class="truncate">{{ getFieldLabel(condition.get('fieldKey')?.value) }}</span>
             <img [src]="isDropdownOpen('field', i) ? commonService.Images.DROPDOWN_ICON_NEW_UX_HOVER_PRIMARY_BLUE_THEME : commonService.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown"  />
            <!-- <img [src]="commonService.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown" [ngClass]="{'rotate-180': isDropdownOpen('field', i)}" /> -->
          </div>
          <ng-template cdkConnectedOverlay
               [cdkConnectedOverlayOrigin]="fieldOrigin"
               [cdkConnectedOverlayOpen]="isDropdownOpen('field', i) && fieldOrigin.elementRef.nativeElement.offsetWidth > 0"
               [cdkConnectedOverlayWidth]="isDropdownOpen('field', i) ? fieldOrigin.elementRef.nativeElement.offsetWidth : 0"
               [cdkConnectedOverlayPositions]="dropdownPositions"
               [cdkConnectedOverlayPush]="true"
               [cdkConnectedOverlayViewportMargin]="8"
               (overlayKeydown)="$event.key === 'Escape' && closeDropdown()"
               (detach)="onDropdownDetached('field', i)">
            <div
               class="custom-select-menu !hoverShadowOnDropdown "
               role="listbox"
               [attr.aria-label]="'Field options for condition ' + (i + 1)">
            <div *ngFor="let opt of getFieldOptions()"
                 class="custom-select-option"
                 [class.custom-select-option--disabled]="isFieldRestricted(opt.key, i)"
                 [class.custom-select-option--selected]="condition.get('fieldKey')?.value === opt.key"
                 role="option"
                 [attr.tabindex]="isFieldRestricted(opt.key, i) ? -1 : 0"
                 [attr.aria-disabled]="isFieldRestricted(opt.key, i)"
                 [attr.aria-selected]="condition.get('fieldKey')?.value === opt.key"
                 (click)="selectField(opt.key, i, $event)"
                 (keydown.enter)="selectField(opt.key, i, $event)"
                 (keydown.space)="$event.preventDefault(); selectField(opt.key, i, $event)">
              {{ opt.label }} {{ isFieldRestricted(opt.key, i) ? '(Already used)' : '' }}
            </div>
          </div>
          </ng-template>
        </div>

        <!-- Dynamic Value Input -->
        <ng-container *ngIf="getFieldConfig(condition.get('fieldKey')?.value) as activeConfig; else emptyInput">
          
          <!-- Custom dropdown for selectable values -->
          <div *ngIf="['select-string', 'checkbox', 'radio', 'select-object'].includes(activeConfig.type)"
               class="flex-1 relative w-[15rem] min-w-0 hoverShadow">
            <div class="custom-select-trigger rounded-md border border-card_number_color cursor-pointer text-primary_Text_Color px-4 text-xs bg-white outline-none poppinsMedium"
                 [ngClass]="{
                   'border-red_600': condition.get('value')?.invalid && condition.get('value')?.touched,
                   'border-primary_Bg_Button_Color': isDropdownOpen('value', i),
                   '!text-my_profile_secondary_text': !isDropdownOpen('value', i) && condition.get('value')?.invalid
                 }"
                 cdkOverlayOrigin #valueOrigin="cdkOverlayOrigin"
                 role="combobox"
                 tabindex="0"
                 [attr.aria-label]="'Value for condition ' + (i + 1)"
                 aria-haspopup="listbox"
                 [attr.aria-expanded]="isDropdownOpen('value', i)"
                 (click)="toggleDropdown('value', i, $event)"
                 (keydown)="handleDropdownKeydown($event, 'value', i)">
              <span class="truncate">{{ getValueLabel(activeConfig, condition.get('value')?.value) }}</span>
              <!-- <span class="custom-select-chevron" [class.rotate-180]="isDropdownOpen('value', i)" aria-hidden="true">⌄</span> -->
                          <img [src]="commonService.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown" [ngClass]="{'rotate-180':isDropdownOpen('value', i)}" />
            </div>
            <ng-template cdkConnectedOverlay
                 [cdkConnectedOverlayOrigin]="valueOrigin"
                 [cdkConnectedOverlayOpen]="isDropdownOpen('value', i) && valueOrigin.elementRef.nativeElement.offsetWidth > 0"
                 [cdkConnectedOverlayWidth]="isDropdownOpen('value', i) ? valueOrigin.elementRef.nativeElement.offsetWidth : 0"
                 [cdkConnectedOverlayPositions]="dropdownPositions"
                 [cdkConnectedOverlayPush]="true"
                 [cdkConnectedOverlayViewportMargin]="8"
                 (overlayKeydown)="$event.key === 'Escape' && closeDropdown()"
                 (detach)="onDropdownDetached('value', i)">
              <div
                   class="custom-select-menu"
                   role="listbox"
                   [attr.aria-label]="'Value options for condition ' + (i + 1)">
                <div *ngFor="let option of getValueOptions(activeConfig)"
                     class="custom-select-option"
                     [class.custom-select-option--selected]="valuesEqual(getOptionValue(activeConfig, option), condition.get('value')?.value)"
                     role="option"
                     tabindex="0"
                     [attr.aria-selected]="valuesEqual(getOptionValue(activeConfig, option), condition.get('value')?.value)"
                     (click)="selectValue(getOptionValue(activeConfig, option), i, $event)"
                     (keydown.enter)="selectValue(getOptionValue(activeConfig, option), i, $event)"
                     (keydown.space)="$event.preventDefault(); selectValue(getOptionValue(activeConfig, option), i, $event)">
                  {{ getOptionLabel(activeConfig, option) }}
                </div>
              </div>
            </ng-template>
          </div>

          <!-- Date Input -->
          <div *ngIf="activeConfig.type === 'date'" class="flex-1 w-[15rem] min-w-0">
            <app-date-time-picker
              formControlName="value"
              mode="date"
              [fontFamily]="'poppinsMedium'"
              [placeholder]="activeConfig.placeholder || 'Select date'"
              [cssClass]="'px-3  min-h-10 text-primary_Text_Color text-xs staffing-newux-styles ' + (condition.get('value')?.invalid && condition.get('value')?.touched ? 'border-red_600' : '')">
            </app-date-time-picker>
          </div>

          <!-- Ageing range -->
          <div *ngIf="condition.get('fieldKey')?.value === 'ageing'" class="ageing-range flex-1 flex items-center gap-2 bg-white">
            <div class="ageing-day-field !py-0 min-h-10 !px-2 hoverShadow">
              <input #startDayInput type="number"  formControlName="startDay" min="0" [attr.max]="ageing?.maxAgeing ?? ageing?.maximumAgeingLimit"
                     aria-label="startDay" (input)="onAgeingRangeChange(i)"
                     [style.width.ch]="startDayInput.value.length || 5"
                     class="ageing-day-input bg-transparent text-primary_Text_Color text-xs poppinsMedium outline-none">
              <span class="ageing-day-unit text-xs poppinsRegular">days</span>
              <div class="ageing-stepper">
                <button type="button" aria-label="Increase start day" [disabled]="startDayInput.disabled || startDayInput.readOnly"
                        (pointerdown)="startAgeingStep($event, startDayInput, 1)"
                        (pointerup)="stopAgeingStep()" (pointercancel)="stopAgeingStep()" (lostpointercapture)="stopAgeingStep()"
                        (click)="$event.detail === 0 && stepAgeingDay(startDayInput, 1)">
                  <img src="assets/images/ageing-step-up.svg" alt="" aria-hidden="true">
                </button>
                <button type="button" aria-label="Decrease start day" [disabled]="startDayInput.disabled || startDayInput.readOnly"
                        (pointerdown)="startAgeingStep($event, startDayInput, -1)"
                        (pointerup)="stopAgeingStep()" (pointercancel)="stopAgeingStep()" (lostpointercapture)="stopAgeingStep()"
                        (click)="$event.detail === 0 && stepAgeingDay(startDayInput, -1)">
                  <img src="assets/images/ageing-step-down.svg" alt="" aria-hidden="true">
                </button>
              </div>
            </div>
            <span class="text-xs text-primary_Text_Color">to</span>
            <div class="ageing-day-field !py-0 min-h-10 !px-2 hoverShadow"
             [ngClass]="{'has-error': condition.get('value')?.invalid && condition.get('value')?.touched}">
              <input #endDayInput type="number" formControlName="endDay" min="0" [attr.max]="ageing?.maxAgeing ?? ageing?.maximumAgeingLimit"
                     aria-label="endDay"  (input)="onAgeingRangeChange(i)"
                     [style.width.ch]="endDayInput.value.length || 5"
                     class="ageing-day-input bg-transparent text-primary_Text_Color text-xs poppinsMedium outline-none">
              <span class="ageing-day-unit text-xs poppinsRegular">days</span>
              <div class="ageing-stepper">
                <button type="button" aria-label="Increase end day" [disabled]="endDayInput.disabled || endDayInput.readOnly"
                        (pointerdown)="startAgeingStep($event, endDayInput, 1)"
                        (pointerup)="stopAgeingStep()" (pointercancel)="stopAgeingStep()" (lostpointercapture)="stopAgeingStep()"
                        (click)="$event.detail === 0 && stepAgeingDay(endDayInput, 1)">
                  <img src="assets/images/ageing-step-up.svg" alt="" aria-hidden="true">
                </button>
                <button type="button" aria-label="Decrease end day" [disabled]="endDayInput.disabled || endDayInput.readOnly"
                        (pointerdown)="startAgeingStep($event, endDayInput, -1)"
                        (pointerup)="stopAgeingStep()" (pointercancel)="stopAgeingStep()" (lostpointercapture)="stopAgeingStep()"
                        (click)="$event.detail === 0 && stepAgeingDay(endDayInput, -1)">
                  <img src="assets/images/ageing-step-down.svg" alt="" aria-hidden="true">
                </button>
              </div>
            </div>
          </div>

          <!-- Standard input for other text and number fields -->
          <input *ngIf="condition.get('fieldKey')?.value !== 'ageing' && ['text', 'range', 'number'].includes(activeConfig.type)"
                 type="text" formControlName="value" appAppNoSpaces placeholder="Enter value"
                 [ngClass]="{'border-red_600': condition.get('value')?.invalid && condition.get('value')?.touched}"
                 class="flex-1 rounded-md border border-card_number_color px-3 min-h-10 text-primary_Text_Color  w-[15rem] text-xs poppinsMedium focus:border-primary_Bg_Button_Color outline-none">
        </ng-container>

        <!-- Fallback disabled input if no field is selected -->
        <ng-template #emptyInput>
          <input type="text" disabled placeholder="Enter value"  appAppNoSpaces
                 [ngClass]="{'border-red_600': condition.get('value')?.invalid && condition.get('value')?.touched}"
                 class="flex-1 hoverShadow rounded-md border border-card_number_color px-3 text-primary_Text_Color min-h-10 w-[15rem] text-xs bg-white focus:border-primary_Bg_Button_Color outline-none poppinsMedium">
        </ng-template>

        <!-- Delete Condition Button (Trash Icon) -->
         <div
          (click)="removeCondition(i,$event)"  class="bg-white  hover:bg-[#E3E8F6] cursor-pointer w-10 h-10 border border-card_Bg_Color hover:border-transparent items-center flex justify-center rounded-lg">
            <img
              class="w-4 h-4"
              [src]="commonService.Images.DELETE_BOLD"
              alt="delete icon"
            />
        </div>
      </div>
    </div>

    <!-- Error Message Display Area -->
    <div *ngIf="errorMessage" class="px-5 mb-4">
      <p class="text-red_600 text-xs poppinsMedium bg-red-50 p-2 rounded border border-red-300 flex items-center gap-1">
        ⚠️ {{ errorMessage }}
      </p>
    </div>
    <div *ngIf="ageingFieldError" class="px-5 mb-4">
      <p class="text-red_600 text-xs poppinsMedium bg-red-50 p-2 rounded border border-red-300 flex items-center gap-1">
        ⚠️ {{ ageingFieldError }}
      </p>
    </div>

    <!-- Footer Actions -->
    <div class="border-t border-gray-200 pt-4 px-5">
      <div class="flex justify-between items-center">
        <!-- <button type="button" (click)="addCondition()" class="text-blue-600 poppinsMedium hover:text-blue-800 text-xs flex items-center gap-1 transition-colors">
          <span class="text-lg leading-none">+</span> Add Condition
        </button> -->
         <button
            type="button"
            (click)="addCondition()"
            (mouseenter)="currentAddFieldImg = hoverAddFieldImg"
            (mouseleave)="currentAddFieldImg = defaultAddFieldImg"
            class="text-primary_Bg_Button_Color flex items-center text-xs 2xl:text-sm justify-center gap-1 hover:text-hovered_primary_blue hover:poppinsSemibold  poppinsMedium"
          >
            <img [src]="currentAddFieldImg" class="w-4 h-4" alt="" aria-hidden="true" />
            Add Condition
          </button>
        
        <button type="button" (click)="saveFilter()" [disabled]="isSaving" class="text-xs 2xl:text-sm poppinsMedium textBasedActions">
          {{ isSaving ? 'Saving...' : 'Save Filter' }}
        </button>
      </div>
    </div>
  </form>
</div>
